// Centralized contact details and the single WhatsApp entry point used by every CTA.
// Keeping the number and the link-builder here avoids duplicating the wa.me URL
// (and the `noopener,noreferrer` hardening) across the section components.

export const WHATSAPP_NUMBER = '+393937169038';

export const DEMO_MESSAGE = 'Ciao, vorrei richiedere una demo di ChatLy';

/** Open a pre-filled WhatsApp chat in a new, isolated tab. */
export const openWhatsApp = (message: string = DEMO_MESSAGE): void => {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
